import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";

const selectors = {
  sectionIntro: ".animation--section-introduction > *",
  item: ".grid-display__item",
};

export default node => {
  if (!shouldAnimate(node)) return;

  delayOffset(node, [selectors.sectionIntro, selectors.item]);

  const observer = intersectionWatcher(node, true);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
